const CONTROL_NUMBER_DIVISOR = 97;

const LENGTHS = {
  CONTROL_NUMBER: 2,
  REFERENCE_NUMBER: 10,
} as const;

const NOT_DIGIT = /[^\d]/g;

const PAD_CHAR = '0';

const RADIX = 10;

const STRUCTURED_REFERENCE_IDENTIFIER = '+++';

const appendControlNumber = (digits: string) => {
  const referenceNumber = digits
    .substring(0, LENGTHS.REFERENCE_NUMBER)
    .padEnd(LENGTHS.REFERENCE_NUMBER, PAD_CHAR);

  const modulo = Number.parseInt(referenceNumber, RADIX) % CONTROL_NUMBER_DIVISOR;

  const controlNumber =
    modulo === 0
      ? CONTROL_NUMBER_DIVISOR.toString()
      : modulo.toString().padStart(LENGTHS.CONTROL_NUMBER, PAD_CHAR);

  return referenceNumber + controlNumber;
};

const canBeOGM = (value: string | null | undefined) =>
  !!value?.startsWith(STRUCTURED_REFERENCE_IDENTIFIER);

const isValidOGM = (value: string | null | undefined) => {
  if (!value) return false;

  const ogmDigits = value.replaceAll(NOT_DIGIT, '');

  return appendControlNumber(ogmDigits) === ogmDigits;
};

export { canBeOGM, isValidOGM, STRUCTURED_REFERENCE_IDENTIFIER };
